// ─────────────────────────────────────────────────────────────────────────────
// Purchase-price bounds for the borrower's home-price inputs.
//
// ⚠️ KEEP IN LOCKSTEP WITH backend/constants/afmMatrix.js. The frontend cannot
// import from backend/, so these exist twice by necessity;
// backend/test/uwPolicyParity.test.js fails if the two ever disagree.
//
// ⚠️ WHAT WAS HERE BEFORE: `const MIN_PRICE = 150000` — written out by hand in
// TWO components, and wrong in a way neither made visible. 150,000 is
// PROGRAM.loanMin, a LOAN minimum. Using it as a PRICE minimum silently assumed
// 100% LTV, which no Doorly tier offers. At the loosest published LTV (0.90) the
// smallest financeable purchase is $166,667, so the old floor accepted prices
// between $150,000 and $166,666 that cannot produce a qualifying loan.
//
// ⚠️ THE MAXIMUM IS A PROGRAM CEILING AND IS DELIBERATELY NOT FICO-AWARE.
// "Make it accurate per borrower" is not the improvement it appears to be: a
// per-borrower ceiling depends on FICO and down payment, and on this screen the
// borrower has often supplied neither. The bound would start wide and TIGHTEN
// as the form fills — a maximum that moves while you type reads as the system
// changing its mind, rejecting a figure it accepted a moment earlier with no
// visible cause. Eligibility belongs to Atlas, which sees the whole file at
// once and can explain a single answer. This only catches a price no Doorly
// product could finance under any circumstances.
//
// ⚠️ IT APPLIES TO EVERYONE, INCLUDING BORROWERS WITH NO APPROVAL — it is a
// program boundary, not an approval-derived one. The approved-borrower screen
// additionally caps at their own approved amount, which is a different and
// stricter question; this is the floor and ceiling of the product itself.
// ─────────────────────────────────────────────────────────────────────────────

// PROGRAM.loanMin (150,000) ÷ the loosest tier LTV (0.90).
export const PURCHASE_PRICE_MIN = 150000;
// PROGRAM.loanMax (3,000,000) ÷ the tightest tier LTV (0.70).
export const PURCHASE_PRICE_MAX = 4285714;
